interface AcctSetupOptionProps {
  icon: string;
  isTrial?: boolean;
  content: React.ReactNode;
  onClick: () => void;
}

function AcctSetupOption({
  icon = '',
  isTrial,
  content,
  onClick,
}: AcctSetupOptionProps) {
  return (
    <div
      className="relative border-2 border-neutral-500 text-center h-60 bg-white w-72 rounded-md flex flex-col justify-center items-center px-8 cursor-pointer hover:bg-green-50 hover:border-neutral-400"
      onClick={onClick}
    >
      <div
        className={`absolute top-0 right-0 border-l-2 border-l-neutral-400 rounded-tr rounded-bl border-b-2 border-b-neutral-400 ${isTrial ? 'bg-gray-100' : 'bg-green-200'} py-1 px-5`}
      >
        <span>{isTrial ? 'Trial' : 'Client'}</span>
      </div>
      <img
        className="h-7 w-7 mb-2"
        src={`${process.env.PUBLIC_URL}/static/img/${icon}`}
      />
      <div className="text-lg">{content}</div>
    </div>
  );
}

export default AcctSetupOption;
